import React, { useState, useEffect } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { Box, Button, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const PaymentMethodStatus = ({ childRouteSearch }) => {
	const stripe = useStripe();
	const [message, setMessage] = useState(null);
	const history = useHistory();

	useEffect(() => {
		if (!stripe) {
			return;
		}

		// Retrieve the "setup_intent_client_secret" query parameter appended to
		// your return_url by Stripe.js
		const clientSecret = new URLSearchParams(childRouteSearch).get(
			'setup_intent_client_secret'
		);

		// Retrieve the SetupIntent
		stripe.retrieveSetupIntent(clientSecret).then(({ setupIntent }) => {
			// Inspect the SetupIntent `status` to indicate the status of the payment
			// to your customer.
			//
			// Some payment methods will [immediately succeed or fail][0] upon
			// confirmation, while others will first enter a `processing` state.
			//
			// [0]: https://stripe.com/docs/payments/payment-methods#payment-notification
			console.log('setupIntent', setupIntent);

			switch (setupIntent.status) {
				case 'succeeded':
					setMessage('Success! Your payment method has been saved.');
					break;

				case 'processing':
					setMessage(
						"Processing payment details. We'll update you when processing is complete."
					);
					break;

				case 'requires_payment_method':
					// Redirect your user back to your payment page to attempt collecting
					// payment again
					setMessage(
						'Failed to process payment details. Please try another payment method.'
					);
					break;
				default:
					setMessage('Unknown response from stripe!');
			}
		});
	}, [stripe]);

	return (
		<Box sx={{ textAlign: 'center' }}>
			<Typography variant="h6" component="div" sx={{ mb: 4 }}>
				PAYMENT METHOD CONFIRMATION
			</Typography>
			<Typography variant="body" component="div" sx={{ mb: 4 }}>
				{message}
			</Typography>
			<Button
				variant="outlined"
				onClick={e => {
					history.push('/account/personal/paymentmethods');
				}}>
				VIEW PAYMENT METHODS
			</Button>
			<Button
				sx={{ ml: 1 }}
				variant="outlined"
				onClick={e => {
					history.push('/account/services/current');
				}}>
				SET UP RECURRING PAYMENTS
			</Button>
		</Box>
	);
};

export default PaymentMethodStatus;
